import { StateModel } from 'src/shared/models';
import {
  GET_SURVEY_TRANSLATIONS_REQUEST,
  GET_SURVEY_TRANSLATIONS_SUCCESS,
  GET_SURVEY_TRANSLATIONS_ERROR,
  CLEAR_TRANSLATIONS,
} from '../actions/content-translations.action';

const INITIAL_STATE: StateModel = {
  loading: false,
  loaded: false,
  error: null,
  data: {},
};

export const contentTranslationsSurveyReducer = (
  state: StateModel = INITIAL_STATE,
  { type, payload, error }: any,
) => {
  switch (type) {
    case GET_SURVEY_TRANSLATIONS_REQUEST:
      return {
        ...state,
        loaded: false,
        loading: true,
      };
    case GET_SURVEY_TRANSLATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: payload,
      };
    case GET_SURVEY_TRANSLATIONS_ERROR:
      return {
        ...state,
        loading: false,
        loaded: false,
        error,
      };
    case CLEAR_TRANSLATIONS: {
      return { INITIAL_STATE };
    }
    default:
      return state;
  }
};
